import { ComponentProps } from 'react';

import { observer } from 'mobx-react';

import { useFilterBarManagerInitialData } from './hooks';
import FilterBarManager from './filter-bar-manager';

export const FilterBarManagerWithInitialData = observer((props: ComponentProps<typeof FilterBarManager>) => {
	const { initialDataReady } = useFilterBarManagerInitialData();

	return initialDataReady ? <FilterBarManager {...props} /> : null;
});
